import { FC, useMemo } from 'react'

import { Tinode } from '@inno-sdk/livechat-sdk'
import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useMountApp } from 'modules/app-registry/hooks/useMountApp'
import { useUserContext } from 'shared/hooks/useUserContext'

interface CallWidgetProps {
  tinode: typeof Tinode
  isLoggedIn: boolean
}

export const CallWidget: FC<CallWidgetProps> = ({ tinode, isLoggedIn }) => {
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  const appProps = useMemo(
    () => ({ tinode, isLoggedIn, user }),
    [tinode, isLoggedIn, user]
  )

  const { ref, isLoaded, isError } = useMountApp(
    {
      url: process.env.REACT_APP_LIVE_CHAT_V2_APP_DEV_PATH,
      scope: 'livechat_v2',
      envKey: apps[AppId.LIVE_CHAT].runtimeEnvKey,
      entryPath: './LiveChatCallWidget'
    },
    appProps
  )

  if (isError || !isLoaded || !user) return null

  return <div ref={ref} />
}
